// utils/storyUtils.js
export function extractPersonIDsFromContent(content) {
    const ids = new Set();

    const walk = (nodes) => {
        if (!nodes || !Array.isArray(nodes)) return;

        for (const node of nodes) {
            if (node.type === 'link' && typeof node.url === 'string') {
                const match = node.url.match(/\/person\/(I\d+)/);
                if (match) {
                    ids.add(match[1]);
                }
            }

            // Recursief zoeken in nested children
            if (node.children) {
                walk(node.children);
            }
        }
    };

    walk(content);
    return [...ids];
}
